import React from 'react';
import Link from 'gatsby-link';

import styled from 'styled-components';
import _ from 'lodash';

// Utils
import { backgroundTheme, media } from '../../styles/style-utils';

const PageWrapper = styled.section``;
const ListsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const PagesList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 4rem 0;
`;

const PageItem = styled.li`
  h2 {
    font-size: 2rem;
  }

  width: 200px;
  margin: 0 2rem 2rem 0;
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-right: 2px solid rgba(0, 0, 0, 0.4);
  border-bottom: 2px solid rgba(0, 0, 0, 0.4);
  border-color: ${props => props.themeColors[0]};
`;

const ThemeBar = styled.div`
  background: ${props => backgroundTheme(props.themeColors)};
  height: 10px;
  width: 100%;
`;

const PagesPage = ({ data }) => {

  const grouped = _.groupBy(data.allSitePage.edges, e => e.node.context && e.node.context.type ? e.node.context.type : 'page');

  return (
    <PageWrapper>
      <h1>The Pages</h1>
      <p>Here are all of the html pages baked out by Gatsby...</p>
      <p><i>I've given them a type by providing a context in the createPage call at build time, in gatsby-node.js.</i></p>
      <ListsWrapper>
        <PagesList>
          <h2>Foods ({grouped.food.length})</h2>
          <p>Created from Sheets data</p>
          {grouped.food.map(({ node }) => (
            <PageItem key={node.id} themeColors={node.context.content.themecolor.split('-')}>
              <Link to={node.path}><h2>{node.path}</h2></Link>
            </PageItem>
          ))}
        </PagesList>
        <PagesList>
        <h2>Nutrients ({grouped.nutrient.length})</h2>
        <p>Created from Markdown files</p>
        {grouped.nutrient.map(({ node }) => (
          <PageItem key={node.id} themeColors={['black']}>
          <Link to={node.path}><h2>{node.path}</h2></Link>
          </PageItem>
        ))}
        </PagesList>
        <PagesList>
          <h2>Diets ({grouped.diet.length})</h2>
          <p>Created from Markdown files</p>
          {grouped.diet.map(({ node }) => (
            <PageItem key={node.id} themeColors={['black']}>
              <Link to={node.path}><h2>{node.path}</h2></Link>
            </PageItem>
          ))}
        </PagesList>
        <PagesList>
          <h2>Other ({grouped.page.length})</h2>
          <p>Created from Page Components</p>
          {_.orderBy(grouped.page, ({ node }) => node.path.length).map(({ node }) => (
            <PageItem key={node.id} themeColors={['black']}>
              <Link to={node.path}><h2>{node.path}</h2></Link>
            </PageItem>
          ))}
        </PagesList>
      </ListsWrapper>

    </PageWrapper>
  );
};

export const query = graphql`
  query PagesQuery {
    allSitePage {
      edges {
        node {
          id
          path
          internalComponentName
          layout
          context {
            type
            content {
              id
              title
              themecolor
              textcolor
            }
          }
        }
      }
    }
  }
`;

export default PagesPage;



// WEBPACK FOOTER //
// ./src/pages/jamstack/pages.js